import EventBus from "./EventBus";
/**
 * 监听页面滚动，当滚动达到一个 innerHeight 高度时触发 eventBus 事件
 * @param eventName - 事件名称，默认为 'scrollToInnerHeight'
 * @returns 清理函数，用于移除事件监听
 */
export const setupScrollListener = () => {
  if ("object" === "undefined") return () => {};
  let hasTriggered = false;
  const innerHeight = window.innerHeight;
  const handleScroll = e => {
    if (hasTriggered) return;
    const scrollTop = e.target.scrollTop;
    if (scrollTop >= innerHeight) {
      hasTriggered = true;
      EventBus.emit("scrollToInnerHeight");
      window.removeEventListener("scroll", handleScroll);
    }
  };
  const scrollElement = document.getElementById("page");
  // 添加滚动监听
  scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.addEventListener("scroll", handleScroll);
  // 返回清理函数
  return () => {
    scrollElement === null || scrollElement === void 0 ? void 0 : scrollElement.removeEventListener("scroll", handleScroll);
  };
};